import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderEdit"><Path d="M4.5 10.0586C5.88071 10.0586 7 11.1779 7 12.5586V18.4727L4.5 20.9727L2 18.4727V12.5586C2 11.1779 3.11929 10.0586 4.5 10.0586Z" fill="currentColor"/><Path d="M12.5352 6H22V20H8.30078L9 19.3008V12.5586C9 10.0733 6.98528 8.05859 4.5 8.05859C3.57492 8.05859 2.71505 8.33776 2 8.81641V3H10.5352L12.5352 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderEdit;
